<template>
  <div>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg3 pl-6>
                <v-layout row wrap justify-end>
                    <v-menu
                        v-model="menuStart"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                            v-model="computedStartDateFormatted"
                            :label="$t('revenue_report_details.from_date')"
                            hint="DD-MM-YYYY"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                    </v-menu>
                </v-layout>
            </v-flex>
            <v-flex lg3 pl-6>
                <v-layout row wrap justify-end>
                    <v-menu
                        v-model="menuEnd"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                            v-model="computedEndDateFormatted"
                            :label="$t('revenue_report_details.to_date')"
                            hint="DD-MM-YYYY"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                    </v-menu>
                </v-layout>
            </v-flex>
            <v-flex lg2 pl-6 pt-0 v-if="roleAdmin">
                <v-select :label="$t('revenue_report_details.report_by')" :items="report_types" v-model="reportType" item-text="name" item-value="value"></v-select>
            </v-flex>
            <v-flex lg2 pl-6 pt-0 v-if="reportType !== 'all' && roleAdmin">
                <v-autocomplete :label="user_title" :items="user_list" v-model="uidSelected" item-text="Username" item-value="ID"></v-autocomplete>
            </v-flex>
            <v-flex lg2 pl-6>
                <v-btn @click="filter_data" color="#a41c21" outlined>{{ $t('actions.view') }}</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex lg12 v-if="items && items.length > 0">
                <v-card class="mb-4">
                    <v-card-title>{{ $t('revenue_report_details.chart_title') }}</v-card-title>
                    <v-card-text>
                        <highcharts :options="chartOptions"></highcharts>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex lg12 v-if="items">
                <v-data-table hide-default-footer :headers="headers" :items="items" :server-items-length="items.length" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.ReportDate }}</td>
                            <td class="text-end">{{ item.NumberOfCode | currency }}</td>
                            <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                            <td class="text-end">{{ item.Weight | currency('', 1) }}</td>
                            <td class="text-end">{{ item.Volume | currency('', 2) }}</td>
                            <td class="text-end">{{ item.Deposit | currency('¥', 1) }}</td>
                            <td class="text-end">{{ item.FeeShipVND | currency }}</td>
                            <td class="text-end">{{ item.DiscountAmount | currency }}</td>
                            <td class="text-end">{{ item.AmountVND | currency }}</td>
                            <td class="text-end">{{ item.TotalCost | currency }}</td>
                            <td class="text-end">{{ item.TotalProfit | currency }}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr>
                            <td class="font-weight-bold">{{ $t('truck_report.total_summary').toUpperCase() }}</td>
                            <td class="text-end font-weight-bold">{{dic_summary.NumberOfCode | currency}}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.NumberOfPack | currency }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.Weight | currency('', 1) }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.Volume | currency('', 2) }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.Deposit | currency('¥', 1) }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.FeeShipVND | currency }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.DiscountAmount | currency }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.AmountVND | currency }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.TotalCost | currency }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.TotalProfit | currency }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        return {
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            viewName: "thong-ke-nap-tien",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            recharge_methods: configs.RECHARGE_METHODS,
            staffName: '',
            method: 0,
            reportType: 'all',
            user_list: [],
            uidSelected: 0,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        reportType() {
            if(this.reportType == 'customer') {
                this.user_list = this.customers;
            }
            else if(this.reportType == 'sale') {
                this.user_list = this.staffs;
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.report.revenues.data,
            loading: state => state.report.loading,
            staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return (
                    o.RoleID == configs.ROLE_TYPE.Sale
                );
            }),
            customers: state => state.commons.customers,
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        roleAdmin() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Payment;
        },
        report_types() {
            return [
                { 'value': 'all', 'name': this.$t('revenue_report_details.company') },
                { 'value': 'customer', 'name': this.$t('revenue_report_details.customer') },
                { 'value': 'sale', 'name': this.$t('revenue_report_details.sale') }
            ];
        },
        user_title() {
            if (this.reportType === 'customer') {
                return this.$t('revenue_report_details.select_customer');
            } else if (this.reportType === 'sale') {
                return this.$t('revenue_report_details.select_sale');
            }
            return '';
        },
        dic_summary() {
            return {
                'NumberOfCode': _.sumBy(this.items, 'NumberOfCode'),
                'NumberOfPack': _.sumBy(this.items, 'NumberOfPack'),
                'Weight': _.sumBy(this.items, 'Weight'),
                'Volume': _.sumBy(this.items, 'Volume'),
                'Deposit': _.sumBy(this.items, 'Deposit'),
                'FeeShipVND': _.sumBy(this.items, 'FeeShipVND'),
                'DiscountAmount': _.sumBy(this.items, 'DiscountAmount'),
                'AmountVND': _.sumBy(this.items, 'AmountVND'),
                'TotalCost': _.sumBy(this.items, 'TotalCost'),
                'TotalProfit': _.sumBy(this.items, 'TotalProfit'),
            };
        },
        headers() {
            return [
                {
                    text: this.$t('table_headers.date'),
                    value: "ReportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: this.$t('table_headers.bill_count'),
                    value: "NumberOfCode",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.pack_count'),
                    value: "NumberOfPack",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.weight'),
                    value: "Weight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.volume'),
                    value: "Volume",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.deposit'),
                    value: "Deposit",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.fee_ship_vnd'),
                    value: "FeeShipVND",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.discount_amount'),
                    value: "DiscountAmount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('revenue_report_details.revenue'),
                    value: "AmountVND",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.cost'),
                    value: "TotalCost",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.profit'),
                    value: "TotalProfit",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
            ];
        },
        filter_params() {
            let param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                report_type: this.reportType,
                uidSelected: this.uidSelected,
                pagination: {
                    sortDesc: this.pagination.sortDesc,
                    sortBy: this.pagination.sortBy
                }
            }
            if(this.staffName != '') {
                param.staffName = this.staffName;
            }
            if(this.method != 0) {
                param.method = this.method;
            }
            return param;
        },
        chartOptions() {
            if (!this.items || this.items.length === 0) {
                return {};
            }
            
            const categories = this.items.map(item => item.ReportDate);
            const revenueData = this.items.map(item => item.AmountVND);
            const profitData = this.items.map(item => item.TotalProfit);
            const costData = this.items.map(item => item.TotalCost);
            const self = this;
            
            return {
                chart: {
                    type: 'column',
                    height: 400
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: categories,
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: this.$t('revenue_report_details.amount_y_axis')
                    }
                },
                tooltip: {
                    shared: true,
                    useHTML: true,
                    formatter: function() {
                        let s = '<b>' + this.x + '</b><br/>';
                        this.points.forEach(point => {
                            s += '<span style="color:' + point.color + '">\u25CF</span> ' + 
                                 point.series.name + ': <b>' + 
                                 point.y.toLocaleString('vi-VN') + ' ' + self.$t('revenue_report_details.currency_unit') + '</b><br/>';
                        });
                        return s;
                    }
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                series: [
                    {
                        name: this.$t('revenue_report_details.revenue'),
                        data: revenueData,
                        color: '#2196F3'
                    },
                    {
                        name: this.$t('revenue_report_details.cost'),
                        data: costData,
                        color: '#FF5722'
                    },
                    {
                        name: this.$t('revenue_report_details.profit'),
                        data: profitData,
                        color: '#4CAF50'
                    }
                ],
                credits: {
                    enabled: false
                }
            };
        }
    },
    methods: {
        filter_data: function () {
            this.$store.dispatch("report/getRevenueReport", this.filter_params);
        },
        exportData() {
            this.$store.dispatch("report/exportList", this.filter_params);
        }
    },
    mounted() {
        this.$store.dispatch("commons/getAllUsers");
        this.$store.dispatch("commons/getAllCustomer");
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("REQUEST_EXPORT_ACTION", this.exportData);
    }
};
</script>